import createFrontendConfig from './createFrontendConfig';

const envConfig = createFrontendConfig();

export default envConfig;
